import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import React from "react"
import ReactDOM from "react-dom"
import "./styles/gobble.scss"
import { BannerBar } from "./components/BannerBar"
import { SignupFormFields } from "./components/SignupFormFields"
import { SignupForm } from "./components/SignupForm"
import { Disclaimer } from "./components/Disclaimer"
import { PricingCalculator } from "./components/PricingCalculator"
import { MenuCarousel } from "./components/MenuCarousel"
import { ProductCarousel } from "./components/ProductCarousel"
import { UpcomingMenus } from "./components/UpcomingMenus"
import { CampaignLanding } from "./components/CampaignLanding"
import { PromoChecker } from "./components/PromoChecker"

declare const window: any

window.React = React
window.ReactDOM = ReactDOM

window.MenuCarousel = MenuCarousel
window.ProductCarousel = ProductCarousel
window.UpcomingMenus = UpcomingMenus
window.BannerBar = BannerBar
window.SignupFormFields = SignupFormFields
window.SignupForm = SignupForm
window.Disclaimer = Disclaimer
window.PricingCalculator = PricingCalculator
window.CampaignLanding = CampaignLanding
window.PromoChecker = PromoChecker
